export const userStateType = {
  EMAIL_VERIFIED: 'REGISTER_EMAIL_VERIFIED',
  PHONE_VERIFIED: 'REGISTER_PHONE_VERIFIED',
  DOCUMENT_VERIFIED: 'REGISTER_DOCUMENT_VERIFIED',
  PASSWORD_VERIFIED: 'REGISTER_PASSWORD_VERIFIED',
  FULL_REGISTER_REQUIRED: 'BLOCKED_IS_FULL_REGISTER_REQUIRED',
  ACTIVED: 'ACTIVE',
};
